import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { SetTitleGuard } from './guards/set-title.guard';

export function provideTitle(): EnvironmentProviders {
  return makeEnvironmentProviders([SetTitleGuard]);
}
